"use client";
import type { ReactElement } from "react";
import { Fragment } from "react";
import { motion, type MotionValue } from "framer-motion";
import { TRANSITIONS } from "@/utils/animation";
import { NEEDLE_DOT_SIZE, TRACK_DRAW_DURATION_MS, TRACK_GRADIENT, TRACK_HEIGHT, TRACK_HIGHLIGHT_WIDTH, } from "./timeline-constants";
import { selectTimelineNeedleDotShadow } from "./timeline-root-selectors";
import type { TimelineLayoutMetrics } from "./timeline-root-types";
const NEEDLE_HIGHLIGHT_HEIGHT = 12;
const NEEDLE_HIGHLIGHT_VERTICAL_OFFSET = 6;
const NEEDLE_DOT_SPRING_STIFFNESS = 500;
const NEEDLE_DOT_SPRING_DAMPING = 20;
export interface TimelineTrackProps {
    hasSnapCandidates: boolean;
    isNeedleReady: boolean;
    layout: TimelineLayoutMetrics;
    needleOpacity: MotionValue<number>;
    snappedNeedleX: MotionValue<number>;
    snappedSectionColor: string;
    trackHighlightGradient: string;
}
export function TimelineTrack({ hasSnapCandidates, isNeedleReady, layout, needleOpacity, snappedNeedleX, snappedSectionColor, trackHighlightGradient, }: TimelineTrackProps): ReactElement {
    return (
      <Fragment>
        <motion.div initial={{ scaleX: 0, opacity: 0.7 }} animate={{ scaleX: 1, opacity: 1 }} transition={{
            duration: TRACK_DRAW_DURATION_MS / 1000,
            ...TRANSITIONS.smooth,
        }} style={{
            position: "absolute",
            left: 0,
            top: layout.trackY - TRACK_HEIGHT / 2,
            width: layout.contentWidth,
            height: TRACK_HEIGHT,
            transformOrigin: "left",
            backgroundImage: TRACK_GRADIENT,
            zIndex: 2,
        }}/>

        {isNeedleReady && hasSnapCandidates && (<motion.div style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: layout.chartHeight,
                x: snappedNeedleX,
                opacity: needleOpacity,
                zIndex: 4,
                pointerEvents: "none",
            }}>
            <div style={{
                position: "absolute",
                left: -TRACK_HIGHLIGHT_WIDTH / 2,
                top: layout.trackY - NEEDLE_HIGHLIGHT_VERTICAL_OFFSET,
                width: TRACK_HIGHLIGHT_WIDTH,
                height: NEEDLE_HIGHLIGHT_HEIGHT,
                backgroundImage: trackHighlightGradient,
            }}/>

            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{
                type: "spring",
                stiffness: NEEDLE_DOT_SPRING_STIFFNESS,
                damping: NEEDLE_DOT_SPRING_DAMPING,
            }} style={{
                position: "absolute",
                left: -NEEDLE_DOT_SIZE / 2,
                top: layout.trackY - NEEDLE_DOT_SIZE / 2,
                width: NEEDLE_DOT_SIZE,
                height: NEEDLE_DOT_SIZE,
                borderRadius: "50%",
                backgroundColor: snappedSectionColor,
                boxShadow: selectTimelineNeedleDotShadow({
                    sectionColor: snappedSectionColor,
                }),
            }}/>
          </motion.div>)}
      </Fragment>
    );
}
